import { useEffect, useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/Dialog';
import { Button } from '../ui/Button';
import { RadioCard, RadioGroup } from '../ui/RadioGroup';
import pt from '../../locales/pt';
import { payloadFromCategoryAllocation } from '../../utils/categoryAllocation';

const ALLOCATION_OPTIONS = [
  {
    value: 'essential',
    id: 'classify-allocation-essential',
    labelKey: 'allocationEssential',
    hintKey: 'allocationEssentialHint',
  },
  {
    value: 'lifestyle',
    id: 'classify-allocation-lifestyle',
    labelKey: 'allocationLifestyle',
    hintKey: 'allocationLifestyleHint',
  },
  {
    value: 'personal_investment',
    id: 'classify-allocation-investment',
    labelKey: 'allocationInvestment',
    hintKey: 'allocationInvestmentHint',
  },
];

/**
 * Classificar órfã: escolher tipo → PATCH budget_allocation.
 */
export function ClassifyOrphanDialog({
  isOpen,
  onClose,
  category,
  onSubmit,
  isPending,
}) {
  const [allocation, setAllocation] = useState('essential');

  useEffect(() => {
    if (isOpen) setAllocation('essential');
  }, [isOpen, category?.id]);

  if (!category) return null;

  const submit = () => {
    onSubmit({
      id: category.id,
      payload: payloadFromCategoryAllocation(allocation),
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{pt.categories.orphans.classifyTitle}</DialogTitle>
          <DialogDescription>
            {pt.categories.orphans.classifyDescription.replace(
              '{name}',
              category.name,
            )}
          </DialogDescription>
        </DialogHeader>

        <RadioGroup
          value={allocation}
          onValueChange={setAllocation}
          className="flex flex-col gap-2"
        >
          {ALLOCATION_OPTIONS.map((option) => (
            <RadioCard
              key={option.value}
              value={option.value}
              id={option.id}
              label={pt.categories.form[option.labelKey]}
              description={pt.categories.form[option.hintKey]}
            />
          ))}
        </RadioGroup>

        <div className="flex justify-end gap-2 pt-2">
          <Button type="button" variant="ghost" onClick={onClose}>
            {pt.common.cancel}
          </Button>
          <Button type="button" onClick={submit} disabled={isPending}>
            {pt.categories.orphans.classifySubmit}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
